export default __webpack_public_path__ + "static/media/radio_button_checked-teal.b9e610cc.svg";